<div class="flex" style="justify-content: center;align-items:center;padding: 100px 0;width: 100vw;flex-direction: column;gap: 2rem;color: rgb(0, 179, 172);">
    <h1 style="font-weight: 700;">404</h1>
    <h2 style="font-weight: 600;font-size: 25px;">Oops!</h2>
    <div style="text-align: center;">
        <h3 style="margin-bottom: 0.75rem;">We're sorry,</h3>
        <h3>The page you were looking for doesn't exist anymore</h3>
    </div>
    <button routerLink="/">Back To Home</button>
</div>